// Device roles as the backend's DeviceRole ordinals, with Spanish labels for the UI.
export const ROLES = [
  { value: 1, label: 'Termómetro', name: 'Thermometer' },
  { value: 2, label: 'Calefactor', name: 'Heater' },
];

// Role arrives as a numeric ordinal from the unassigned registry and as the enum name ("Heater") from
// the room read path; map either to the Spanish label.
export const roleLabel = (role) =>
  ROLES.find(r => String(r.value) === String(role) || r.name === role)?.label ?? role;

export const isHeater = (role) => role === 'Heater' || role === 2;
